import { Card as MuiCard, Typography } from '@material-ui/core';
import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Card = styled(MuiCard)<Theme>(({ theme }) => ({
  boxShadow: theme.shadows[3],
  color: theme.colors.grey.dark,
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(5),
  padding: `${theme.spacing(6)}px 9.25vw`,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(2),
  },
}));

export const StyledTeaser = styled('div')<Theme>(() => ({
  textAlign: 'left',
}));

export const Title = styled(Typography)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
}));
